import { render, staticRenderFns } from "./certificates-filters-index.vue?vue&type=template&id=e6c54726&scoped=true"
import script from "./certificates-filters-index.vue?vue&type=script&lang=js"
export * from "./certificates-filters-index.vue?vue&type=script&lang=js"
import style0 from "./certificates-filters-index.vue?vue&type=style&index=0&id=e6c54726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c54726",
  null
  
)

export default component.exports